import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import dsteem from "../unit/DsteemUtil";
import { extractLoginData } from "../unit/UserUtil";
export default {
  name: "vote-model",
  props: ["showModel", "post"],
  data: function data() {
    return {
      value: 0,
      title: "",
      isJoined: false,
      isShowButton: false,
      loginData: null
    };
  },
  methods: {
    votePost: function votePost() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _newActivity$username;

        var newActivity, result, _newActivity$username2, data, that;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!_this.isShowButton || _this.isJoined)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this.isShowButton = false;
                newActivity = _this.post;
                _context.next = 6;
                return dsteem.getPostDetails((_newActivity$username = newActivity.username) !== null && _newActivity$username !== void 0 ? _newActivity$username : newActivity.author, newActivity.permlink);

              case 6:
                result = _context.sent;

                if (!result) {
                  _context.next = 10;
                  break;
                }

                if (!result.active_votes.some(function (item) {
                  return item.voter == _this.loginData[0];
                })) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return");

              case 10:
                if (_this.loginData) {
                  data = new Object();
                  data.postingKey = _this.loginData[1];
                  data.weight = 10000 * _this.value / 100;
                  data.voter = _this.loginData[0];
                  data.author = (_newActivity$username2 = newActivity.username) !== null && _newActivity$username2 !== void 0 ? _newActivity$username2 : newActivity.author;
                  data.permlink = newActivity.permlink;
                  that = _this;

                  if (_this.loginData[4] == "true") {
                    window.steem_keychain.requestVote(data.voter, data.permlink, data.author, data.weight, function (response) {
                      that.$emit("votePost");
                      that.isJoined = true;
                    });
                  } else {
                    dsteem.voteBlog(data);

                    _this.$emit("votePost");

                    _this.isJoined = true;
                  }
                } else {
                  _this.$bus.emit("openLogin");
                }

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    closeModel: function closeModel() {
      this.$emit("closeModel");
    },
    openModel: function openModel() {
      var _this2 = this;

      this.loginData = extractLoginData();

      if (!this.loginData && this.showModel) {
        this.$bus.emit("openLogin");
        return;
      }

      this.title = this.post.title;
      var newActivity = this.post;

      if (newActivity) {
        if (newActivity.active_votes.some(function (item) {
          return item.voter == _this2.loginData[0];
        })) {
          this.isJoined = true;
        } else {
          this.isJoined = false;
        }
      }

      this.isShowButton = true;
    }
  },
  watch: {
    post: function post(newval) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _newActivity$username3;

        var newActivity, result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.title = newval.postsTitle;
                newActivity = newval;
                _context2.next = 4;
                return dsteem.getPostDetails((_newActivity$username3 = newActivity.username) !== null && _newActivity$username3 !== void 0 ? _newActivity$username3 : newActivity.author, newActivity.permlink);

              case 4:
                result = _context2.sent;

                if (result && _this3.loginData) {
                  if (result.active_votes.some(function (item) {
                    return item.voter == _this3.loginData[0];
                  })) {
                    _this3.isJoined = true;
                  } else {
                    _this3.isJoined = false;
                  }
                }

                _this3.isShowButton = true;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    showModel: function showModel() {
      this.loginData = extractLoginData();

      if (!this.loginData && this.showModel) {
        this.$bus.emit("openLogin");
      }
    }
  },
  mounted: function mounted() {}
};